import { gql } from '@apollo/client';

export default gql`
  fragment AgreementFragment on Agreement {
    id
    title
    content
    creationDate
  }
`;
